export default {
    new: 'Neu',
    extension: 'Verlängerung',

    organisation: 'Träger',
    cardOwner: 'Jugendleiter',
}
